export type ParsedSubPageId =
  | { kind: "email"; emailId: string }
  | { kind: "document"; documentId: string; emailId: string | undefined };

/**
 * Parse the Teams `subPageId` context value into a navigation target.
 *
 * Formats emitted by the bot:
 *   - `email:<emailId>`            → email detail drawer
 *   - `doc:<documentId>:<emailId>` → document review (with back-link hint)
 *
 * Anything else with content is treated as a legacy bare document id —
 * older cards in channel history encoded only the SharePoint item id.
 */
export function parseSubPageId(raw: string | null | undefined): ParsedSubPageId | null {
  if (!raw) return null;

  if (raw.startsWith("email:")) {
    const emailId = raw.slice("email:".length);
    return emailId ? { kind: "email", emailId } : null;
  }

  if (raw.startsWith("doc:")) {
    const rest = raw.slice("doc:".length);
    const sep = rest.indexOf(":");
    if (sep === -1) {
      return rest ? { kind: "document", documentId: rest, emailId: undefined } : null;
    }
    const documentId = rest.slice(0, sep);
    const emailId = rest.slice(sep + 1);
    if (!documentId) return null;
    return { kind: "document", documentId, emailId: emailId || undefined };
  }

  return { kind: "document", documentId: raw, emailId: undefined };
}
